export const CONTEXTUAL_HELP_KEYS = {
  DASHBOARD_INBOX: 'dashboard_inbox',
  KANBAN: 'kanban',
  CONTACTS: 'contacts',
  GENERAL_SETTINGS: 'general_settings',
  CORTEX: 'cortex',
};

export const CONTEXTUAL_HELP = {
  [CONTEXTUAL_HELP_KEYS.DASHBOARD_INBOX]: {
    tourCompletedKey: 'dashboard_tour_completed',
    articleKey: 'manual.conversations.inbox',
    titleKey: 'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.TITLE',
    steps: [
      {
        element: '#sidebar-menu-wrapper',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.SIDEBAR.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.SIDEBAR.DESCRIPTION',
      },
      {
        element: '#sidebar-main-modules',
        titleKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.MAIN_MENUS.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.MAIN_MENUS.DESCRIPTION',
      },
      {
        element: '#sidebar-group-contacts',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.CONTACTS.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.CONTACTS.DESCRIPTION',
      },
      {
        element: '#sidebar-configurable-modules',
        collapseBefore: {
          trigger: {
            selector: '#sidebar-group-conversation [role="button"]',
          },
          visibleTarget: '#sidebar-group-conversation-children',
        },
        titleKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.CONFIGURABLE_BLOCKS.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.CONFIGURABLE_BLOCKS.DESCRIPTION',
      },
      {
        element: '#sidebar-group-settings',
        expandBefore: {
          trigger: {
            eventName: 'chatplan:sidebar-expand:Settings',
          },
          visibleTarget: '#sidebar-group-settings-children',
        },
        titleKey: 'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.SETTINGS.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.SETTINGS.DESCRIPTION',
      },
      {
        element: '#sidebar-profile-menu-toggle',
        clickOnNext: {
          eventName: 'chatplan:sidebar-profile-menu:open',
          defer: 150,
        },
        waitAfterNext: {
          waitUntilVisible: '#sidebar-profile-menu .n-dropdown-body',
          retryAction: {
            eventName: 'chatplan:sidebar-profile-menu:open',
          },
        },
        titleKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.USER_MENU_BUTTON.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.USER_MENU_BUTTON.DESCRIPTION',
      },
      {
        element: '#sidebar-profile-menu .n-dropdown-body',
        activeLayer: true,
        deferred: true,
        collapseOnDeselected: {
          trigger: {
            eventName: 'chatplan:sidebar-profile-menu:close',
          },
          visibleTarget: '#sidebar-profile-menu',
        },
        titleKey: 'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.USER_MENU.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.USER_MENU.DESCRIPTION',
      },
      {
        element: '#dashboard-inbox-conversation-list',
        titleKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.CONVERSATIONS.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.CONVERSATIONS.DESCRIPTION',
      },
      {
        element: '#dashboard-inbox-first-conversation',
        optional: true,
        waitUntilPresent: '#dashboard-inbox-first-conversation',
        skipWhenPresent: '#dashboard-inbox-conversation-list-empty',
        clickOnNext: '#dashboard-inbox-first-conversation .conversation',
        waitAfterNext: [
          { waitUntilPresent: '#conversation-messages-view' },
          { waitUntilGone: '#conversation-messages-loading' },
          { waitUntilPresent: '#conversation-contact-sidebar-toggle' },
        ],
        titleKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.FIRST_CONVERSATION.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.FIRST_CONVERSATION.DESCRIPTION',
      },
      {
        element: '#conversation-list-view-controls',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.FILTERS.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.FILTERS.DESCRIPTION',
      },
      {
        element: '#dashboard-inbox-help-actions',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.ACTIONS.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.ACTIONS.DESCRIPTION',
      },
      {
        element: '#dashboard-inbox-conversation-list',
        includeWhenPresent: '#dashboard-inbox-conversation-list-empty',
        excludeWhenPresent: '#conversation-messages-view',
        titleKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.EMPTY_MESSAGES.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.EMPTY_MESSAGES.DESCRIPTION',
      },
      {
        element: '#conversation-message-panel',
        includeWhenPresent: [
          '#dashboard-inbox-first-conversation',
          '#conversation-messages-view',
        ],
        titleKey: 'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.MESSAGES.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.MESSAGES.DESCRIPTION',
      },
      {
        element: '#conversation-reply-composer',
        deferred: true,
        includeWhenPresent: [
          '#dashboard-inbox-first-conversation',
          '#conversation-messages-view',
        ],
        resolveOnHighlight: true,
        titleKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.REPLY_COMPOSER.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.REPLY_COMPOSER.DESCRIPTION',
      },
      {
        element: '#conversation-contact-sidebar-toggle',
        deferred: true,
        includeWhenPresent: [
          '#dashboard-inbox-first-conversation',
          '#conversation-messages-view',
        ],
        clickOnNext: {
          selector: '#conversation-contact-sidebar-toggle',
          timeout: 4000,
        },
        waitAfterNext: {
          waitUntilPresent: '#conversation-contact-summary',
        },
        titleKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.CONTACT_SIDEBAR_TOGGLE.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.CONTACT_SIDEBAR_TOGGLE.DESCRIPTION',
      },
      {
        element: '#conversation-contact-sidebar',
        deferred: true,
        includeWhenPresent: [
          '#dashboard-inbox-first-conversation',
          '#conversation-messages-view',
        ],
        resolveOnHighlight: true,
        titleKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.CONTEXT_PANEL.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.CONTEXT_PANEL.DESCRIPTION',
      },
      {
        element: '#conversation-contact-summary',
        deferred: true,
        includeWhenPresent: [
          '#dashboard-inbox-first-conversation',
          '#conversation-messages-view',
        ],
        resolveOnHighlight: true,
        titleKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.CONTACT_SUMMARY.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.CONTACT_SUMMARY.DESCRIPTION',
      },
      {
        element: '#conversation-contact-sidebar-sections',
        deferred: true,
        includeWhenPresent: [
          '#dashboard-inbox-first-conversation',
          '#conversation-messages-view',
        ],
        resolveOnHighlight: true,
        titleKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.CONTACT_SECTIONS.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.CONTACT_SECTIONS.DESCRIPTION',
      },
      {
        element: '.woot-widget-bubble:not(.woot--hide)',
        optional: true,
        titleKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.SUPPORT_WIDGET.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.DASHBOARD_INBOX.STEPS.SUPPORT_WIDGET.DESCRIPTION',
      },
    ],
  },
  [CONTEXTUAL_HELP_KEYS.KANBAN]: {
    tourCompletedKey: 'kanban_tour_completed',
    articleKey: 'manual.crm.kanban',
    titleKey: 'PRODUCT_TOUR.CONTEXTS.KANBAN.TITLE',
    steps: [
      {
        element: '#kanban-pipeline-selector',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.KANBAN.STEPS.PIPELINE.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.KANBAN.STEPS.PIPELINE.DESCRIPTION',
      },
      {
        element: '#kanban-status-filter',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.KANBAN.STEPS.STATUS.TITLE',
        descriptionKey: 'PRODUCT_TOUR.CONTEXTS.KANBAN.STEPS.STATUS.DESCRIPTION',
      },
      {
        element: '#kanban-new-deal-button',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.KANBAN.STEPS.DEAL.TITLE',
        descriptionKey: 'PRODUCT_TOUR.CONTEXTS.KANBAN.STEPS.DEAL.DESCRIPTION',
      },
    ],
  },
  [CONTEXTUAL_HELP_KEYS.CONTACTS]: {
    tourCompletedKey: 'contacts_tour_completed',
    articleKey: 'manual.contacts',
    titleKey: 'PRODUCT_TOUR.CONTEXTS.CONTACTS.TITLE',
    steps: [
      {
        element: '#contacts-search-input',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.CONTACTS.STEPS.SEARCH.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.CONTACTS.STEPS.SEARCH.DESCRIPTION',
      },
      {
        element: '#toggleContactsFilterButton',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.CONTACTS.STEPS.FILTERS.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.CONTACTS.STEPS.FILTERS.DESCRIPTION',
      },
      {
        element: '#contacts-help-actions',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.CONTACTS.STEPS.ACTIONS.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.CONTACTS.STEPS.ACTIONS.DESCRIPTION',
      },
    ],
  },
  [CONTEXTUAL_HELP_KEYS.GENERAL_SETTINGS]: {
    tourCompletedKey: 'settings_general_tour_completed',
    articleKey: 'manual.general_settings',
    titleKey: 'PRODUCT_TOUR.CONTEXTS.GENERAL_SETTINGS.TITLE',
    steps: [
      {
        element: '#general-settings-account-name',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.GENERAL_SETTINGS.STEPS.NAME.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.GENERAL_SETTINGS.STEPS.NAME.DESCRIPTION',
      },
      {
        element: '#general-settings-site-language',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.GENERAL_SETTINGS.STEPS.LANGUAGE.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.GENERAL_SETTINGS.STEPS.LANGUAGE.DESCRIPTION',
      },
      {
        element: '#general-settings-save-button',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.GENERAL_SETTINGS.STEPS.SAVE.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.GENERAL_SETTINGS.STEPS.SAVE.DESCRIPTION',
      },
    ],
  },
  [CONTEXTUAL_HELP_KEYS.CORTEX]: {
    tourCompletedKey: 'cortex_tour_completed',
    articleKey: 'manual.cortex.overview',
    titleKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.TITLE',
    steps: [
      {
        element: '#cortex-navigation',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.NAVIGATION.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.NAVIGATION.DESCRIPTION',
      },
      {
        element: '#cortex-overview-status',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.STATUS.TITLE',
        descriptionKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.STATUS.DESCRIPTION',
      },
      {
        element: '#cortex-overview-group-agents',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.AGENTS.TITLE',
        descriptionKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.AGENTS.DESCRIPTION',
      },
      {
        element: '#cortex-overview-group-knowledge',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.KNOWLEDGE.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.KNOWLEDGE.DESCRIPTION',
      },
      {
        element: '#cortex-overview-group-settings',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.MODELS.TITLE',
        descriptionKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.MODELS.DESCRIPTION',
      },
      {
        element: '#cortex-overview-group-tools',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.TOOLS.TITLE',
        descriptionKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.TOOLS.DESCRIPTION',
      },
      {
        element: '#cortex-overview-group-costs',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.COSTS.TITLE',
        descriptionKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.COSTS.DESCRIPTION',
      },
      {
        element: '#cortex-overview-group-audit',
        optional: true,
        titleKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.AUDIT.TITLE',
        descriptionKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.AUDIT.DESCRIPTION',
      },
      {
        element: '#cortex-overview-checklist',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.CHECKLIST.TITLE',
        descriptionKey:
          'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.CHECKLIST.DESCRIPTION',
      },
      {
        element: '#cortex-help-actions',
        titleKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.HELP.TITLE',
        descriptionKey: 'PRODUCT_TOUR.CONTEXTS.CORTEX.STEPS.HELP.DESCRIPTION',
      },
    ],
  },
};

export const getContextualHelpConfig = systemKey => CONTEXTUAL_HELP[systemKey];
